function Container({ className = '', style = {}, ...props }) {
    return (
        <div className={`loop-grid-container ${className}`} style={style}>
            {props.children}
        </div>
    );
}

function Item({ styles = {}, id = null, className = '', row = undefined, width = undefined, ...props }) {

    return (
        <div
            id={id}
            className={`loop-grid-item ${className}`}
            style={{ ...styles, gridRow: row ? `${row} / span 1` : undefined, gridColumn: width ? `${width}` : undefined }}
        >
            {props.children}
        </div>
    );
}

function Item2({ styles = {}, id = null, className = '', row = undefined, width = undefined, ...props }) {

    return (
        <div
            id={id}
            className={`${className}`}
            style={{ ...styles, gridRow: row ? `${row} / span 1` : undefined, gridColumn: width ? `${width}` : undefined }}
        >
            {props.children}
        </div>
    );
}

export default Object.assign(Container, {
    Container: Container,
    Item: Item,
    Item2: Item2,
});
